import React from 'react'
import { Portrait, CardOrientationOptions } from 'component-library/cards/Portrait/Portrait'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import { CardRouteProps } from 'component-library/cards/card-props.routing'
import { ImpressionAvailable } from 'component-library/__helpers/impression-available-helper'
import {
    getVideoQueue,
    VideoQueue,
} from 'component-library/templates/Publication/lib/get-video-queue'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { MediaMode } from '../CardMedia/CardMedia'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { createCollectionAvailableEvent } from 'common/events/collection-events'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export const PortraitRegistration = createRegisterableComponentWithData(
    'portrait',
    ContentDataDefinitionLoader,
    (
        props: CardRouteProps & {
            isSponsoredCollection?: boolean
            verticalSpacing?: keyof ThemeMargins
            cardOrientation?: CardOrientationOptions
            willPlayVideoInline?: boolean
            hasPadding?: boolean
            mediaMode?: MediaMode
            fullWidthOnMobile?: boolean
        },
        data,
        services
    ) => {
        if (data.loaded && data.result.publications.length === 0) {
            // Can happen if we are driven by a curation and publication(s) have been killed
            services.log.warn('Portrait card received empty list of publications')
            return null
        }

        const results = data.loaded && data.result.publications[0]
        if (results && results.cardType !== 'publication') {
            return null
        }

        const willPlayVideoInline =
            isFeatureEnabled(services.store.getState().toggles, 'inline-card-video') &&
            props.willPlayVideoInline

        return (
            <ImpressionAvailable
                loading={!data.loaded}
                available={() => {
                    if (!data.loaded) {
                        console.warn('Available should never be called when loading is true')
                        return
                    }

                    services.onEvent(
                        createCollectionAvailableEvent(data.result.publications, 'Portrait')
                    )
                }}
            >
                {ref => (
                    <Portrait
                        innerRef={ref}
                        item={results ? { loaded: true, result: results } : { loaded: false }}
                        fixedRatio={props.fixedRatio}
                        fontScale={props.fontScale}
                        onEvent={services.onEvent}
                        hasBackground={props.hasBackground}
                        hasPadding={props.hasPadding}
                        hideTeaser={props.hideTeaser}
                        hideByline={props.hideByline}
                        kickerPosition={props.kickerPosition}
                        isLarge={props.isLarge}
                        isSponsoredCollection={props.isSponsoredCollection}
                        verticalSpacing={props.verticalSpacing}
                        cardOrientation={props.cardOrientation}
                        cardNumber={1}
                        willPlayVideoInline={willPlayVideoInline}
                        getVideoQueue={() =>
                            results
                                ? getVideoQueue(services, results.id)
                                : Promise.resolve<VideoQueue>({
                                      type: 'not-playlist-video',
                                      items: [],
                                  })
                        }
                        adUnitPath={services.adState.targeting.adUnitPath}
                        timestamp={props.timestamp}
                        mediaMode={props.mediaMode}
                        fullWidthOnMobile={props.fullWidthOnMobile}
                        disableImageLazyLoad={props.disableImageLazyLoad}
                    />
                )}
            </ImpressionAvailable>
        )
    }
)
